"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Zoom = /*#__PURE__*/function () {
  function Zoom(client) {
    (0, _classCallCheck2["default"])(this, Zoom);
    this.client = client;
    this.resourceUrl = '/zoom';
  }
  /**
   * Completes Zoom OAuth. `code` and `state` must be query params, not body.
   */


  (0, _createClass2["default"])(Zoom, [{
    key: "authenticateCallback",
    value: function authenticateCallback(code, state) {
      var params = new URLSearchParams({
        code: code,
        state: state
      });
      return this.client.post("".concat(this.resourceUrl, "/authenticate/callback?").concat(params.toString()), {});
    }
  }, {
    key: "getAccount",
    value: function getAccount() {
      return this.client.get("".concat(this.resourceUrl, "/account"));
    }
  }, {
    key: "disconnectZoom",
    value: function disconnectZoom() {
      return this.client["delete"]("".concat(this.resourceUrl, "/account"));
    }
  }]);
  return Zoom;
}();

exports["default"] = Zoom;